import React from 'react';
import _ from '../../../shared/utils/ObjectUtils';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import {Responsive} from "react-grid-layout";
import WidthProvider from "../../utils/WidthProvider";
import {I18n} from "react-redux-i18n";
import WidgetUtils from "../../utils/WidgetUtils";
import LazyLoad from "react-lazyload";
import WidgetComponentsByType from "./configuration/WidgetComponentsByType";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

class WidgetsArea extends React.Component {

    render() {
        const {
            loading,
            error,
            onEditMode,
            isDashboardFullScreen,
            layout,
            widgetsConfigs,
            onLayoutChange,
        } = this.props;

        if (error) {
            return renderErrorScreen();
        } else if (loading) {
            return <div/>;
        } else if (!loading && _.isEmpty(widgetsConfigs)) {
            return renderNoDataScreen();
        } else {
            return (
                <div style={isDashboardFullScreen ? {paddingTop: "130px"} : {paddingTop: "5rem"}} className={"pr-4 pd-b-2"}>
                    <ResponsiveReactGridLayout
                        rowHeight={125}
                        verticalCompact={true}
                        cols={{lg: 12, xs: 1, xxs: 1}}
                        breakpoints={{lg: 768, xs: 480, xxs: 0}}
                        layout={layout}
                        isDraggable={onEditMode}
                        isResizable={onEditMode}
                        onLayoutChange={onLayoutChange}
                    >
                        {
                            Object.values(widgetsConfigs).map(widgetConfigs => {
                                return (
                                    <div
                                        key={widgetConfigs.id}
                                        id={widgetConfigs.id}
                                        data-grid={{
                                            i: widgetConfigs.id.toString(),
                                            x: parseInt(widgetConfigs.configs.columnIndex, 10),
                                            y: parseInt(widgetConfigs.configs.rowIndex, 10),
                                            h: !_.isNil(widgetConfigs.configs.widgetHeight) ? parseInt(widgetConfigs.configs.widgetHeight, 10) : 4,
                                            w: !_.isNil(widgetConfigs.configs.widgetWidth) ? parseInt(widgetConfigs.configs.widgetWidth, 10) : 4,
                                            minW: WidgetUtils.WidgetDefaultSize[widgetConfigs.type].minW,
                                            maxW: WidgetUtils.WidgetDefaultSize[widgetConfigs.type].maxW,
                                            minH: WidgetUtils.WidgetDefaultSize[widgetConfigs.type].minH,
                                            maxH: WidgetUtils.WidgetDefaultSize[widgetConfigs.type].maxH,
                                        }}
                                    >
                                        <LazyLoad
                                            height={125}
                                            once={true}
                                            offset={625}
                                        >
                                            {
                                                React.createElement(WidgetComponentsByType.for(widgetConfigs.type), widgetConfigs)
                                            }
                                        </LazyLoad>
                                    </div>
                                );
                            }) }
                    </ResponsiveReactGridLayout>
                </div>
            );
        }
    }
}

function renderErrorScreen() {
    return (
        <div style={{alignItems: "center", justifyContent: "center", textAlign: "center", paddingTop: "130px"}}>
            <h1 style={{color: "#9B9B9B"}}>{I18n.t("dashboard.error")}</h1>
        </div>
    );
}

function renderNoDataScreen() {
    return (
        <div style={{alignItems: "center", justifyContent: "center", textAlign: "center", paddingTop: "130px"}}>
            <h1 style={{color: "#9B9B9B"}}>{I18n.t("dashboard.noData")}</h1>
        </div>
    );
}

WidgetsArea.propTypes = {
    onEditMode: PropTypes.bool.isRequired,
    isDashboardFullScreen: PropTypes.bool,
    loading: PropTypes.bool,
    error: PropTypes.bool,
    layout: PropTypes.array,
    widgetsConfigs: PropTypes.object,
    onLayoutChange: PropTypes.func,
};

export default connect(
    null,
    {forwardRef: true}
)(WidgetsArea);